import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Api } from "../../../core/services/api.services";
import { DataResponse } from "../../../shared/interface/data-response";
import { FormDynamic } from "../../../shared/interface/form-dynamic";
import LayoutMain from "../../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton } from "../../../shared/styled/global.styled";
import { FormBase, OptionsSelect } from '../../../shared/interface/form-base';
import SwitchFields from '../../../shared/components/Bc-SwitchFields/Bc-SwitchFields';
import { FormPrimary } from "../../../constants/form";
import { useService } from "../../../hook/useServices";

const getFields = async () => {
  const { data } = await Api.getFields();
  return data;
};

const FormOfForms = () => {
  const serviceQuery = useService('fields', getFields);
  const dataFields = serviceQuery.data as unknown as any[];
  const fields: OptionsSelect[] = dataFields?.map( (field: any) => ({
    value: field.code,
    name: field.name
  }));

  const { id } = useParams();

  if (id) console.log(id);

  const {
    register,
    unregister,
    setValue,
    handleSubmit,
    getValues,
    watch,
    resetField,
    formState: { isValid },
  } = useForm<any>({ mode: "onChange" });
  const onSubmit = handleSubmit((data) => console.log(data));

  const [form, setForm] = useState<FormDynamic>(FormPrimary);

  const getFormId = async () => {
    const { data }: DataResponse<FormDynamic> = await Api.getFormsId(id as string);
    setForm(data);
    console.log(data);
  }


  useEffect(() => {
    if (id) getFormId();
  }, [id]);
  

  return (
    <LayoutMain
      idPage={"Ver Formulario"}
      titlePage={true}
    >
      <form onSubmit={onSubmit} className="bc-container">
        {form?.fields && form.fields.map((field: FormBase) => (
          <SwitchFields key={`master${field.item}`} field={field} register={register} unregister={unregister} setValue={setValue} isRequired={field.isRequired} getValues={getValues} watch={watch} resetField={resetField}  />
        ))}
        <BCButton
          type="submit"
          className="bc-button-primary bc-button-small"
          disabled={!isValid}
        >
          Enviar
        </BCButton>
      </form>
    </LayoutMain>
  );
};

export default FormOfForms;
